import { tryCatchHelper } from '../../helpers';
import {
  ACTIVO_USU_ACTIVIDADES_EXTRACUR,
  ALL_USU_ACTIVIDADES_EXTRACUR,
  LOADING_ALL_USU_ACTIVIDADES_EXTRACUR,
} from './ActividadesExtcurReducer';
import {
  allActividadesExtcurService,
  deleteActividadesExtcurService,
  saveActividadesExtcurService,
} from './ActividadesExtcurService';

export const allActividadesExtcurAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_USU_ACTIVIDADES_EXTRACUR, payload: true });
    const res = await allActividadesExtcurService(params);
    dispatch({ type: ALL_USU_ACTIVIDADES_EXTRACUR, payload: res.data });
    dispatch({ type: LOADING_ALL_USU_ACTIVIDADES_EXTRACUR, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_USU_ACTIVIDADES_EXTRACUR, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveActividadesExtcurAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveActividadesExtcurService(id, data);
    notify(res.data.message);
    await allActividadesExtcurAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoActividadesExtcurAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_USU_ACTIVIDADES_EXTRACUR, payload: data });
};

export const deleteActividadesExtcurAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteActividadesExtcurService(id);
    notify(res.data.message);
    await setActivoActividadesExtcurAction(dispatch, null);
    await allActividadesExtcurAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
